import { NotificationsSettingPath } from '../../../constants/notifications';
import NotificationsSettingStore from '../../../stores/notificationsSettingStore';
import { SCREENS } from 'src/constants/screens';

export const orderStatusNotificationsStore = new NotificationsSettingStore(
  NotificationsSettingPath.ORDER,
  SCREENS.SETTINGS_NOTIFICATIONS_ORDER_STATUS()
);
